
<mdb-card class="mb-3" cascade="true" narrower="true">
    <mdb-card-body cascade="true" class="py-1">
        <div class="row mt-n4 py-3">
            <!-- params -->
            <!-- start date -->
            <div class="col-md-2">
                <div class="mx-2">
                    <div class="md-form form-group">
                        <input type="date" class="form-control" id="startDate" mdbInput>
                        <label for="startDate">Start Date</label>
                    </div>
                </div>
            </div>
            <!-- end date -->
            <div class="col-md-2">
                <div class="mx-2">
                    <div class="md-form form-group">
                        <input type="date" class="form-control" id="endDate" mdbInput>
                        <label for="endDate">End Date</label>
                    </div>
                </div>
            </div>
            <!-- pricing rule -->
            <div class="col-md-2">
                <div class="mx-2">
                    <div class="md-form form-group">
                        <input type="text" class="form-control" id="pricingRule" mdbInput>
                        <label for="pricingRule">Pricing Rule</label>
                    </div>
                </div>
            </div>
            <!-- customer code -->
            <div class="col-md-2">
                <div class="mx-2">
                    <div class="md-form form-group">
                        <input type="text" class="form-control" id="customerCode" mdbInput>
                        <label for="customerCode">Customer Code</label>
                    </div>
                </div>
            </div>
        </div>
    </mdb-card-body>
</mdb-card>

<div *ngIf="(vm$ | async) as vm">    
</div>
